<template>
  <div class="pa-3">
    <div class="d-flex">
      <h3>Cost Centers</h3>
      <v-spacer />
      <v-btn color="primary" flat @click="createCostCenter">
        <v-icon class="mr-1">mdi-plus</v-icon>Cost Center
      </v-btn>
    </div>
    <div
      v-for="costCenter in costCenters"
      :key="costCenter.id"
      class="d-flex align-center mt-2"
    >
      <v-row no-gutters>
        <v-col cols="3">
          <v-text-field
            v-model="costCenter.name"
            label="Name"
            variant="outlined"
            density="compact"
            hide-details
            @update:focused="!$event && costCenter.save()"
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="costCenter.code"
            label="Code"
            variant="outlined"
            density="compact"
            hide-details
            @update:focused="!$event && costCenter.save()"
          />
        </v-col>
      </v-row>
      <v-btn
        class="ml-2"
        icon="mdi-delete"
        flat
        density="compact"
        @click="deleteCostCenter(costCenter)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CostCenter } from "@/classes";
import { useConfirmStore } from "@/store/confirm";
import { useListStore } from "@/store/lists";
import { onMounted, onUnmounted, ref } from "vue";

const $confirm = useConfirmStore();
const lists = useListStore();

const costCenters = ref<CostCenter[]>([]);
onMounted(async () => {
  costCenters.value = await CostCenter.list();
  costCenters.value.sort((a, b) => a.created.getTime() - b.created.getTime());
});
onUnmounted(() => {
  lists.refreshList("costCenters");
});

const createCostCenter = async () => {
  const newCostCenter = new CostCenter();
  await newCostCenter.save();
  costCenters.value.push(newCostCenter);
};

const deleteCostCenter = async (costCenter: CostCenter) => {
  $confirm.open({
    onConfirm: async () => {
      costCenters.value = costCenters.value.filter(
        (d) => d.id !== costCenter.id
      );
      await costCenter.deleteObject();
    },
  });
};
</script>
